// extracted by mini-css-extract-plugin
export default {"page":"Page_Teacher_Salas_page__PgKci","loading":"Page_Teacher_Salas_loading__vUF8n"};